import type React from 'react';
import { SellerProvider } from './SellerProvider';
import { SellerShortcutScope } from './SellerShortcutScope';
import { SellerView } from './SellerView';
import { ShiftProvider } from './shift/ShiftProvider';

/**
 * Seller POS container. Mounts the `SellerProvider` so the product and cart
 * panels share cart/browse state via `useSeller()`, with `ShiftProvider` nested
 * inside so the shift state can read the seller context later. The full-screen
 * layout lives in `SellerView` so this stays a thin composition point.
 * `SellerShortcutScope` pushes the `seller` shortcut scope for as long as the
 * sale screen is mounted.
 */
export const Seller: React.FC = () => (
    <SellerShortcutScope>
        <SellerProvider>
            <ShiftProvider>
                <SellerView />
            </ShiftProvider>
        </SellerProvider>
    </SellerShortcutScope>
);
